import { gql } from "@apollo/client";

export default gql`
  mutation trashComplianceProgramReportingView($id: Int!) {
    deleteComplianceProgramReportingView(id: $id) {
      ok
    }
  }
`;
